import { InputNumber } from "@sellar-io/components";
import { UseFormReturn } from "react-hook-form";
import { InputLabel, InputContainer, InputSelect } from "@sellar-io/components";
import { useRemoteFeatureFlags } from "../../../../../hooks/useRemoteFeatureFlags";
import { useIsSellarAdmin } from "../../../../../hooks/useIsSellarAdmin";
import { MOQ_ITEM_TYPE_OPTIONS } from "../../../../orderRules/orderRule/components/OrderRuleForm.shared";

type PriceTierOrderRuleItemType =
  | "can"
  | "bottle"
  | "keg"
  | "cask"
  | "draught"
  | "any"
  | "bagInBox";

export type PriceTierOrderRuleFormValues = {
  itemType: PriceTierOrderRuleItemType;
  quantity: number;
  volume?: number | null;
  unit?: "L" | null;
};

export const PriceTierOrderRuleForm = ({
  form,
  formId,
  onSave,
}: {
  form: UseFormReturn<PriceTierOrderRuleFormValues>;
  formId: string;
  onSave: (data: PriceTierOrderRuleFormValues) => void;
}) => {
  const register = form.register;
  const isAdmin = useIsSellarAdmin();

  const showGranularOptions =
    useRemoteFeatureFlags().isActive("granularMoq") && isAdmin;

  return (
    <form
      className={"flex flex-col gap-2"}
      id={formId}
      onSubmit={form.handleSubmit((data) => {
        const apiData = {
          itemType: data.itemType,
          quantity: data.quantity,
          volume: data.volume,
          unit: !!data.volume ? data.unit : null,
        };

        onSave(apiData);
      })}
    >
      <div>
        <InputLabel>Container type</InputLabel>
        <InputContainer>
          <InputSelect {...register("itemType", { required: true })}>
            {MOQ_ITEM_TYPE_OPTIONS.map((itemTypeOption) => (
              <option key={itemTypeOption.value} value={itemTypeOption.value}>
                {itemTypeOption.label}
              </option>
            ))}
          </InputSelect>
        </InputContainer>
      </div>

      <div>
        <InputLabel>Container quantity</InputLabel>
        <InputContainer>
          <InputNumber
            {...register("quantity", {
              min: 0,
              required: true,
              valueAsNumber: true,
            })}
            placeholder={"5"}
          />
        </InputContainer>
      </div>

      {showGranularOptions && (
        <>
          <div>
            <InputLabel>Volume</InputLabel>
            <InputContainer>
              <InputNumber
                {...register("volume", {
                  min: 0,
                  valueAsNumber: true,
                })}
                placeholder={"30"}
              />
            </InputContainer>
          </div>

          <div>
            <InputLabel>Unit</InputLabel>
            <InputContainer>
              <InputSelect {...register("unit")}>
                <option value="L">L</option>
                <option value="gal">gal</option>
              </InputSelect>
            </InputContainer>
          </div>
        </>
      )}
    </form>
  );
};
